import Big from 'big.js';
const number = value => new Big(value == null || value === '' ? 0 : value);
const money = (value, scale = 3) =>
	Number(
		number(value)
			.round(scale, 1)
			.toString(),
	);
export function isHairplusFob(company, header, enabled) {
	return company == 'hairplus' && (header.price_basis == 'FOB' || (!header.po_no && !header.sh_no && enabled));
}
export function initializeHairplus(header, items) {
	header.expected_pricing_version = header.pricing_version;
	header._hp_original = {
		total_amount: header.total_amount,
		discount_amount: header.discount_amount,
		received_amount: header.received_amount,
		amounts: items.reduce((sum, row) => sum.plus(number(row.amount)), number(0)).toString(),
		received: items.reduce((sum, row) => sum.plus(number(row.received_amount)), number(0)).toString(),
	};
	items.forEach(row => {
		row._hp_original = {
			quantity: row.quantity,
			unit_price: row.unit_price,
			amount: row.amount,
			received_quantity: row.received_quantity,
			received_amount: row.received_amount,
		};
	});
}
export function defaultHairplusPrice(row, fob) {
	row.im_cost = row.im_cost == null ? row.cost : row.im_cost;
	row.im_fob = row.im_fob == null ? row.fob : row.im_fob;
	row.fob_price = fob ? row.net_price : row.fob;
	row.unit_price = fob ? row.fob_price : row.im_cost;
}
export function validateHairplusPrices(items, fob) {
	if (fob && items.some(row => row.fob_price == null || row.fob_price === '' || Number(row.fob_price) < 0 || !Number.isFinite(Number(row.fob_price)))) return 'Enter a confirmed FOB price for every item. Zero is allowed.';
	return null;
}
export function recalculateHairplus(items, header, fob, shipment = false) {
	let total = number(0),
		received = number(0),
		quantity = number(0),
		received_qty = number(0);
	items.forEach(row => {
		if (fob) row.unit_price = row.fob_price == null ? null : money(row.fob_price);
		const old = row._hp_original;
		row.amount = old && number(old.quantity).eq(number(row.quantity)) && number(old.unit_price).eq(number(row.unit_price)) ? old.amount : money(number(row.quantity).times(number(row.unit_price)));
		row.fob_amount = row.fob_price == null ? null : money(number(row.quantity).times(number(row.fob_price)));
		row.remain_quantity = Number(
			number(row.quantity)
				.minus(number(row.shipped_quantity))
				.toString(),
		);
		row.remain_amount = money(number(row.remain_quantity).times(number(row.unit_price)));
		if (shipment)
			row.received_amount = old && number(old.received_quantity).eq(number(row.received_quantity)) && number(old.unit_price).eq(number(row.unit_price)) ? old.received_amount : money(number(row.received_quantity).times(number(row.unit_price)));
		total = total.plus(number(row.amount));
		received = received.plus(number(row.received_amount));
		quantity = quantity.plus(number(row.quantity));
		received_qty = received_qty.plus(number(row.received_quantity));
	});
	const old = header._hp_original;
	if (old && !fob) {
		total = total
			.plus(number(old.total_amount))
			.minus(number(old.amounts))
			.plus(shipment ? 0 : number(old.discount_amount));
		received = received.plus(number(old.received_amount)).minus(number(old.received));
	}
	header.total_amount = money(total.minus(shipment ? 0 : number(header.discount_amount)), 2);
	header.total_quantity = Number(quantity.toString());
	if (shipment) {
		header.received_amount = money(received, 2);
		header.received_quantity = Number(received_qty.toString());
	} else header.item_amount = money(total);
}
export function propagateHairplusFob(items, index, value) {
	const source = items[index];
	if (value == null || source.im_fob == null) return;
	for (let i = index + 1; i < items.length; i++)
		if (items[i].class_code == source.class_code && items[i].im_fob != null)
			items[i].fob_price = money(
				number(value)
					.plus(number(items[i].im_fob))
					.minus(number(source.im_fob)),
			);
}
